// English translations
const en = {
  // General
  appName: 'LUCIEN14',
  loading: 'Loading...',
  error: 'An error occurred',

  // Navigation
  nav: {
    home: 'Home',
    collections: 'Collections',
    culinary: 'Culinary',
    menu: 'Menu',
    events: 'Events',
    admin: 'Admin'
  },

  // Menu
  menu: {
    title: 'The Menu',
    subtitle: 'CANS NUIT\'s Selection',
    date: 'NOVEMBER 22 2025',
    footer: 'Menu changes seasonally based on inspiration and available ingredients (MERSIN DOES NOT HAVE EVERYTHING — WE TRIED.) Vegetarian options NOT available upon request.',

    // Loading stages
    loading: {
      connecting: 'Connecting to server...',
      fetching: 'Fetching menu data...',
      processing: 'Processing menu items...',
      finalizing: 'Preparing your experience...',
      ready: 'Almost ready...',
      error: 'Connection error',
      notFound: 'Menu not found',
      alternative: 'Trying alternative menu source...',
      hint: 'Our menu is worth the wait. Preparing a culinary journey just for you...'
    },

    // Loading phrases
    loadingPhrases: [
      'Sourcing the finest aluminum...',
      'Consulting the sommelier...',
      'Plating the preservatives...',
      'Opening the cans...',
      'Curating the vibes...'
    ],

    // Section titles
    sections: {
      entrees: 'Starters',
      plats: 'Main Courses',
      cocktails: 'Cocktails',
      whiskies: 'Whiskies',
      gins: 'Gins',
      vins: 'Wines',
      champagnes: 'Champagnes',
      desserts: 'Desserts',
      boissons: 'Beverages'
    },

    // Error states
    errors: {
      unavailable: 'Menu Unavailable',
      subtitle: 'The chef has left the building',
      footer: 'Please order a pizza.',
      title: 'Oh No!'
    }
  },

  // Footer
  footer: {
    designed: 'Designed in the LUCIEN14',
    rights: 'All rights reserved.'
  },

  // Language selector
  language: {
    select: 'Select language',
    en: 'English',
    fr: 'French',
    es: 'Spanish',
    tr: 'Turkish'
  }
};

export default en;
